<!-- 通用form表单组件 -->
<template>
  <el-form
    :inline="inline"
    :model="Form"
    ref="ruleForm"
    :label-width="LabelWidth"
    :hide-required-asterisk="ReadOnly"
    class="demo-ruleForm"
  >
    <template v-for="item in FormItem">
      <template v-if="item.hidden"></template>
      <template v-else>
        <el-form-item
          v-if="
            !item.showItem ||
            (item.showItem && Form[item.showItem] === item.showItemValue)
          "
          :key="item.prop"
          :label="item.label"
          :prop="item.prop"
          :rules="item.rules"
        >
          <template v-if="ReadOnly">
            <template v-if="item.type === 'slot'">
              <slot :name="item.prop"></slot>
            </template>
            <template v-else-if="item.type === 'rich_text'">
              <div v-html="item.prop"></div>
            </template>
            <template v-else>
              <div :style="{ width: item.width || '215px' }">
                <!-- 下拉框，并且没有ViewProp元素。使用option内容匹配 -->
                <template v-if="item.type === 'Update'">
                  <ul>
                    <li v-for="(item, index) in Form[item.prop]" :key="index">
                      <a @click="openFile(item.url)">{{ item.name }}</a>
                    </li>
                  </ul>
                </template>
                <template
                  v-else-if="
                    !item.ViewProp && item.option && item.option.length
                  "
                >
                  {{
                    [item.labelKey] in
                    item.option.find(
                      (item) => item[item.valueKey] === Form[item.prop]
                    )
                      ? item.option.find(
                          (item) => item[item.valueKey] === Form[item.prop]
                        )[item.labelKey]
                      : Form[item.prop]
                  }}
                </template>
                <template v-else>
                  {{ item.ViewProp ? Form[item.ViewProp] : Form[item.prop] }}
                </template>
                <template></template>
              </div>
            </template>
          </template>
          <template v-else>
            <!-- slot -->
            <template v-if="item.type === 'slot'">
              <slot :name="item.prop"></slot>
            </template>
            <base-form-item
              :formItem="item"
              :form="Form"
              @changeValue="changeValue($event, item)"
              @changeValueOther="changeValueOther"
            ></base-form-item>
          </template>
        </el-form-item>
      </template>
    </template>
    <slot name="other"></slot>
    <slot></slot>
  </el-form>
</template>
<script>
import baseFormItem from "./item.vue";
import { deepClone } from "@/utils/deepClone";
export default {
  components: {
    baseFormItem,
  },
  props: {
    /**
     * @param 列表
     *
     * */
    FormItem: {
      type: Array,
      default: () => [],
    },
    /**
     * @param 初始表单数据
     *
     * */

    InitialForm: {
      type: Object,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
    inline: {
      type: Boolean,
      default: false,
    },
    ReadOnly: {
      type: Boolean,
      default: false,
    },
    LabelWidth: {
      type: String,
      default: "100px",
    },
    immediate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      Form: {},
      list: [],
    };
  },
  watch: {
    InitialForm: {
      handler(val) {
        if (val) {
          if (!this.immediate) this.Form = deepClone(val);
          else this.Form = val;
        } else {
          this.Form = {};
        }
      },
      deep: true, // 深度监听
      immediate: true, // 首次监听
    },
  },
  methods: {
    changeValue(data) {
      this.$set(this.Form, data.key, data.value);
      if (this.immediate) {
        // console.log("formUpdate");
        this.$emit("formUpdate", this.Form);
        this.$emit("changeUpdate", {data});
        this.$emit("changeUpdateOther", data);
      }
    },
    changeValueOther(e) {
      this.$emit("changeUpdateOther", e);
    },
    openFile(url) {
      window.open(url);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-select,
.el-date-editor,
.el-radio-group,
.el-upload {
  width: 100% !important;
  text-align: left;
}

a {
  color: blue;
  cursor: pointer;
}
</style>
